import { createAction, props } from '@ngrx/store';
import { IFile } from '@app-root-interfaces';

export const saveFile = createAction('[Download] Save file', props<{ file: IFile; payload: Blob }>());
export const getIniFile = createAction('[Download] Get ini file', props<{ file: IFile }>());

export const downloadFile = createAction('[Download] Download file', props<{ file: IFile }>());
export const downloadFileFailure = createAction('[Download] Download file failure', props<{ file: IFile }>());

export const downloadSnippetFile = createAction(
    '[Download] Download snippet file',
    props<{
        file: IFile;
        formData: { [key: string]: string };
        language: string;
    }>()
);
export const downloadSnippetFileFailure = createAction(
    '[Download] Download snippet file failure',
    props<{ file: IFile }>()
);

export const getFileFailure = createAction('[Download] Get file failure');

export const getMetadata = createAction(
    '[Download] Get metadata',
    props<{
        file: IFile;
        formData: { [key: string]: string };
        language: string;
    }>()
);

export const fillFile = createAction(
    '[Download] Fill file',
    props<{
        file: IFile;
        language: string;
        formData: { [key: string]: string | Array<string> };
    }>()
);

export const downloadManagementInformation = createAction('[Download] Download management information');

export const downloadManagementInformationSuccess = createAction('[Download] Download management information success');

export const downloadLegalInformation = createAction('[Download] Download legal information');

export const downloadLegalInformationSuccess = createAction('[Download] Download legal information success');

export const downloadLocationInformation = createAction('[Download] Download location information');

export const downloadLocationInformationSuccess = createAction('[Download] Download location information success');

export const downloadTranslationInformation = createAction('[Download] Download translation information');

export const downloadTranslationInformationSuccess = createAction(
    '[Download] Download translation information success'
);

export const downloadNotAllowed = createAction('[Download] Download not allowed');

export const fileSentByEmail = createAction('[Download] File Sent By Email', props<{ message: string }>());

export const fileSentByEmailSuccess = createAction('[Download] File Sent By Email Success');

export const fileDownloadReady = createAction(
    '[Download] File Download Ready',
    props<{ file: IFile; data: ArrayBuffer; shouldGetIniFile: boolean }>()
);
